// extracted by mini-css-extract-plugin
export default {"root":"a2WSQb3dkF","input":"osMrruGfge","moreInfo":"hJiwNM8JYp"};